import axios from 'axios';
import api from './api';

const mutationCart = (itemsCart, code) => {
  const lines = itemsCart.reduce(
    (items, line) => [
      ...items,
      {
        quantity: line.quantity,
        merchandiseId: `gid://shopify/ProductVariant/${line.id}`,
      },
    ],
    []
  );

  return JSON.stringify({
    query: `
      mutation createCart($cartInput: CartInput) {
        cartCreate(input: $cartInput) {
          cart {
            lines(first: ${itemsCart.length}) {
              nodes {
                discountAllocations {
                  discountedAmount {
                    amount
                  }
                }
              }
            }
            discountCodes {
              applicable
              code
            }
            discountAllocations {
              discountedAmount {
                amount
              }
            }
          }
        }
      }
    `,
    variables: {
      cartInput: {
        lines,
        discountCodes: [code],
      },
    },
  });
};

export const createCartDiscount = async (code) => {
  try {
    const cart = await api.cart();
    if (!cart.items || !code) return;

    const { data } = await axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '7466c272d7741e8b9bfab266cb9985f2',
      },

      url: `https://thesecondone.myshopify.com/api/2023-01/graphql.json`,
      data: mutationCart(cart.items, code),
    });

    const discountInfo = data.data.cartCreate.cart;

    if (!discountInfo || !discountInfo.discountCodes[0].applicable)
      return {
        error: true,
        message: `${window.cartStrings.error}`,
      };

    return discountInfo;
  } catch (error) {
    console.error(`Error: ${error.message}`);

    return {
      error: true,
      message: `${window.cartStrings.error}`,
    };
  }
};
